const AppRouter  = require('marionette.approuter');
const Controller = require('./controller');

module.exports = AppRouter.default.extend({
    controller: Controller,
    appRoutes:  {
        packages:   'showPackages',
        '*default': 'showHome'
    }
});
